import React from "react";

export default function SectionTitle({ section_id, ish3 = false, section_name, style = {}, h2style = { fontSize: 28 }, isContainer = true, noMargin = false }) {
  const id = section_id;
  const h2Class = noMargin ? "text-start fw-bold mb-2" : "text-start fw-bold  mb-5"
  if (!isContainer) {
    return (
      <>
        {ish3 ?
          <h3 className={h2Class}  >{section_name?.toUpperCase()}</h3>
          :
          <h3 className={h2Class} style={h2style} >{section_name?.toUpperCase()}</h3>
        }
      </>
    );
  } else
    return (
      <div className="container mobile-extra-padding " id={id} style={style}>
        {/* <div className="line"></div> */}
        {ish3 ?
          <h3 className={h2Class}  >{section_name?.toUpperCase()}</h3>
          :
          <h3 className={h2Class} style={h2style} >{section_name?.toUpperCase()}</h3>
        }
        {/* <div className="line"></div> */}
      </div>
    );
}
